module.exports = __webpack_public_path__ + "static/media/tow_truck_default.61836cc8.svg";